/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Score
 */
export interface Score {
    /**
     * 
     * @type {number}
     * @memberof Score
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Score
     */
    category: string;
    /**
     * 
     * @type {number}
     * @memberof Score
     */
    questionsAmount: number;
    /**
     * 
     * @type {number}
     * @memberof Score
     */
    questionsAnsweredAmount: number;
    /**
     * 
     * @type {number}
     * @memberof Score
     */
    correctAnsweredAmount: number;
    /**
     * 
     * @type {number}
     * @memberof Score
     */
    correctPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof Score
     */
    correctAnsweredPercentage: number;
}

/**
 * Check if a given object implements the Score interface.
 */
export function instanceOfScore(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "questionsAmount" in value;
    isInstance = isInstance && "questionsAnsweredAmount" in value;
    isInstance = isInstance && "correctAnsweredAmount" in value;
    isInstance = isInstance && "correctPercentage" in value;
    isInstance = isInstance && "correctAnsweredPercentage" in value;

    return isInstance;
}

export function ScoreFromJSON(json: any): Score {
    return ScoreFromJSONTyped(json, false);
}

export function ScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): Score {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'category': json['category'],
        'questionsAmount': json['questions_amount'],
        'questionsAnsweredAmount': json['questions_answered_amount'],
        'correctAnsweredAmount': json['correct_answered_amount'],
        'correctPercentage': json['correct_percentage'],
        'correctAnsweredPercentage': json['correct_answered_percentage'],
    };
}

export function ScoreToJSON(value?: Score | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'category': value.category,
        'questions_amount': value.questionsAmount,
        'questions_answered_amount': value.questionsAnsweredAmount,
        'correct_answered_amount': value.correctAnsweredAmount,
        'correct_percentage': value.correctPercentage,
        'correct_answered_percentage': value.correctAnsweredPercentage,
    };
}

